import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export default class StatisticsRepository extends EntityBaseRepository {
    public getStatistics(): Promise<AxiosResponse> {
        return this.axiosClient.get('statistics/overall');
    }

    public getSales(from: string, to: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`statistics/sales?from=${from}&to=${to}`);
    }

    /** Windowed activity counts + live snapshot for the Live counts screen. */
    public getCounts(window: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`statistics/counts?window=${window}`);
    }

    public getTaxiCancellations(order: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`statistics/taxi-cancellations?order=${order}`);
    }

    public getDriverTrips(order: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`statistics/driver-trips?order=${order}`);
    }

    public getDriverCancellations(order: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`statistics/driver-cancellations?order=${order}`);
    }

    /** Customers ranked by completed trips in a window, for the customer lookup screen. */
    public getCustomerTrips(window: string, order: string, limit: number): Promise<AxiosResponse> {
        return this.axiosClient.get(`statistics/customer-trips?window=${window}&order=${order}&limit=${limit}`);
    }
}
